export default __webpack_public_path__ + "static/media/pgmico(2).18aad778.png";